import React, { useState, useRef } from "react";
import { injectModels } from "../../redux/injectModels";
import FormData from "form-data";
import { toast } from "react-toastify";


const CreateFaq = (props,getFaq) => {
  const buttonRef = useRef(null);

  const [audioFile, setAudioFile] = useState(null);
  const [audioFileError, setAudioFileError] = useState(null);
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [type, setType] = useState("");
  const [typeError, setTypeError] = useState("");

  const handleTitle = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setTitleError("Title is required!");
    } else {
      setTitleError("");
    }
    setTitle(input);
  };

  const handleType = (event) => {
    const input = event.target.value;
    if (input === "" || input === null) {
      setTypeError("Type is required!");
    } else {
      setTypeError("");
    }
    setType(input.trim());
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    
    if (file) {
      const maxFileSize = 100 * 1024 * 1024; // 100 MB in bytes
  
      if (file.type !== "audio/mpeg") {
        setAudioFile(null);
        setAudioFileError("Please select an audio file in .mp3 format.");
      } else if (file.size > maxFileSize) {
        setAudioFile(null);
        setAudioFileError("File size exceeds 100 MB. Please select a smaller file.");
      } else {
        setAudioFile(file);
        setAudioFileError(null);
      }
    } else {
      setAudioFile(null);
      setAudioFileError("No file selected.");
    }
  };
  

  const handleReset = () => {
    setAudioFile(null);
    setAudioFileError("");
    document.getElementById("audioFileInput").value = "";
    setTitle("");
    setType("");
  };

  // Function to send audio to the backend
  const handleSend = async (event) => {
    event.preventDefault();
    if (!audioFile) {
      setAudioFileError("Please select an audio file first.");
      return;
    }
    if (!title) {
      setTitleError("Title is required!");
      return;
    }
    if (!type) {
      setTypeError("Type is required!");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", type);
    formData.append("audio", audioFile);

    try {
      
      props.application.setLoading(true);
      const response = await props.admin.createFaq(formData);
      if (response) {
        props.application.setLoading(false);
        toast.success(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        const button = buttonRef.current;
        if (button) {
          button.click();
        }
        setTitle("");
        setType("");
      } else {
        props.application.setLoading(false);
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      props.application.setLoading(false);
      console.error("Error uploading audio:", error);
      toast.error("An error occurred while uploading the audio.");
    }
  };

  return (
    <div className="modal fade" id="largeModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Document</h5>
            <button
              ref={buttonRef}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={handleReset}
            ></button>
          </div>
          <div className="modal-body">
            <form className="row g-3 p-2" onSubmit={handleSend}>
              <div className="col-md-12 mt-1"></div>

              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Title
                </label>
                <input
                  type="text"
                  className="form-control"
                  id=""
                  value={title}
                  onChange={handleTitle}
                  maxLength={250}
                />
                {titleError && <div className="text-danger">{titleError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  File Upload
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="audioFileInput"
                  accept=".mp3"
                  onChange={handleFileChange}
                />
                {audioFileError && (
                  <div className="text-danger">{audioFileError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Type
                </label>
                <select
                  className="form-control"
                  id="statusSelect"
                  value={type}
                  onChange={handleType}
                >
                  <option value="">Select type</option>
                  <option value="faq">Faq</option>
                  <option value="script">Script</option>
                  <option value="normaltext">SOP Creation</option>
                </select>
                {typeError && <div className="text-danger">{typeError}</div>}
              </div>

              <div className="mbtn-row">
                <button
                  type="button"
                  className="btn btn-secondary m-0"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary m-0">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectModels(["admin", "application"])(CreateFaq);
